export default "__VITE_ASSET__8db65212__"